<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    :retain-focus="false"
    persistent
    transition="dialog-bottom-transition"
  >
    <!-- Botón de Ver más -->
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" x-small rounded color="primary" dark>
        Ver más
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark class="btn btn-primary" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>{{ formData.reportName }}</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>
            <v-tab v-for="(item, index) in items" :key="index">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, index) in items" :key="index">
          <component :is="getComponent(item)" :report="formData" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import historicMonetization from "@/views/reports/pages/detail_report/components/form_historic_monetization_component.vue";
import confirmMonetization from "@/views/reports/pages/detail_report/components/form_confirm_monetization_component.vue";
import startMonetization from "@/views/reports/pages/detail_report/components/form_start_monetization_component.vue";
import formDetailReport from "@/views/reports/pages/detail_report/components/form_confirm_monetization_component.vue";
import weeklyChartComponent from "@/views/reports/pages/detail_report/components/weekly_chart_component.vue";
import monthlyChartComponent from "@/views/reports/pages/detail_report/components/monthly_chart_component.vue";
import annualChartComponent from "@/views/reports/pages/detail_report/components/annual_chart_component.vue";

export default {
  name: "detailReport",
  components: {
    monthlyChartComponent,
    weeklyChartComponent,
    annualChartComponent,
    historicMonetization,
    confirmMonetization,
    startMonetization,
    formDetailReport,
  },
  props: {
    reportProps: {
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      tab: null,
      items: [],
      formData: {},
    };
  },

  mounted() {
    if (this.reportProps) {
      this.formData = { ...this.reportProps };
      this.items = this.getItems(this.reportProps.reportId);
    }
  },

  methods: {

    closeDialog() {
      this.dialogVisible = false;
      window.location.reload();
    },

    getItems(condition) {
      switch (condition) {
        case 1:
        return ["Iniciar Monetización", "Confirmar Monetización"];
        case 2:
          return ["Análisis Avanzado"];
        case 3:
          return ["Pagos"];
        case 4:
          return ["Semanales", "Mensuales", "Anuales"];
        case 5:
          return ["Datos Completos"];
        default:
          return ["Sin Datos"];
      }
    },

    getComponent(tabName) {
      const componentsMap = {
        "Iniciar Monetización": "startMonetization",
        "Confirmar Monetización": "confirmMonetization",
        "Pagos": "historicMonetization",
        "Semanales": "weeklyChartComponent",
        "Mensuales": "monthlyChartComponent",
        "Anuales": "annualChartComponent",
        "Datos Completos": "formDetailReport",
        "Informe Detallado": "formDetailReport",
        "Análisis Avanzado": "advancedAnalysis",
        "Sin Datos": "formDetailReport",
      };
      return componentsMap[tabName] || "formDetailReport";
    },

  },
  
};

</script>
